<!-- eslint-disable max-len -->
<route>
{
  "meta": {
    "requireAdmin": true,
    "customSite": true
  }
}
</route>
<template>
  <div class="py-1">
    <div v-for="item in items" :key="item.topicId" class="pb-4">
      <div class="my-4 flex items-center justify-between flex-wrap sm:flex-nowrap">
        <div class="ml-2 mt-2">
          <h3 class="text-xl leading-6 font-bold text-gray-900 capitalize">
            {{ item.topicId }}
          </h3>
        </div>
        <div class="ml-4 mt-2 flex-shrink-0">
          <button
            type="button"
            class="btn-primary"
          >
            Add New
          </button>
        </div>
      </div>
      <div class="overflow-hidden border-b border-gray-200">
        <table class="min-w-full divide-y divide-gray-200">
          <thead class="bg-white">
            <tr>
              <th scope="col" class="px-6 py-3 text-left text-xs font-bold text-gray-900 uppercase tracking-wider">
                #
              </th>
              <th scope="col" class="px-6 py-3 text-left text-xs font-bold text-gray-900 uppercase tracking-wider">
                Type
              </th>
              <th scope="col" class="px-6 py-3 text-left text-xs font-bold text-gray-900 uppercase tracking-wider">
                URL
              </th>
              <th scope="col" class="px-6 py-3 text-left text-xs font-bold text-gray-900 uppercase tracking-wider">
                Rating
              </th>
              <th scope="col" class="px-6 py-3 text-left text-xs font-bold text-gray-900 uppercase tracking-wider">
                Enabled
              </th>
              <th scope="col" class="px-6 py-3 text-left text-xs font-bold text-gray-900 uppercase tracking-wider">
                Notes
              </th>
              <th scope="col" class="px-6 py-3 text-left text-xs font-bold text-gray-900 uppercase tracking-wider">
                Constraints
              </th>
              <th scope="col" class="px-6 py-3 text-left text-xs font-bold text-gray-900 uppercase tracking-wider">
                Extra Config
              </th>
              <th scope="col" class="px-6 py-3 text-left text-xs font-bold text-gray-900 uppercase tracking-wider">
                Actions
              </th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200">
            <tr v-for="(source, index) in item.sources" :key="source._id">
              <td class="px-6 py-4 whitespace-nowrap font-thin text-gray-500">
                {{ index + 1 }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-gray-900">
                {{ source.urlType }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-gray-900">
                <a :href="source.url" target="_blank">
                  {{ source.url }}
                </a>
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-gray-900">
                {{ source.feedRating }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-gray-900">
                <toggleSwitch :enabled="source.enabled" :key="source._id" />
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-gray-900">
                {{ source.notes }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-gray-900">
                {{ source.constraints }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-gray-900">
                {{ source.extraConfig }}
              </td>
              <td class="flex px-6 py-4 whitespace-nowrap text-gray-900">
                <div class="px-1">
                  <font-awesome-icon class="reaction text-gray-700 hover:text-blue-500 cursor-pointer" :icon="['far', 'edit']" />
                </div>
                <div class="px-1">
                  <font-awesome-icon
                    class="reaction text-gray-700 hover:text-red-500 cursor-pointer"
                    :icon="['far', 'trash-alt']"
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import toggleSwitch from '@/components/toggleSwitch.vue';
import store from '@/store';
import adminAPI from '@/services/admin';
import utils from '@/services/utils';

export default {
  name: 'sources',
  layout: 'admin',
  store,
  components: { toggleSwitch },
  data() {
    return {
      items: [],
    };
  },
  async mounted() {
    store.commit('toggleLoading', true);
    adminAPI
      .getSources()
      .then((data) => {
        store.commit('toggleLoading', false);
        this.items = data;
      })
      .catch((error) => {
        store.commit('toggleLoading', false);
        if (error.response.status === 401) {
          utils.setStatusMsg(this, 'Unauthorized access, redirected to implicit');
          this.$router.push({ path: '/' });
        }
        console.log({ error });
      });
  },
};
</script>
